import { render } from "./OrganisationPage.vue?vue&type=template&id=19108c93"
import script from "./OrganisationPage.vue?vue&type=script&lang=js"
export * from "./OrganisationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__